import type { ReactElement } from "react";

import type { SaveToListButtonProps } from "../../components/table-actions-panel/SaveToListButton/SaveToListButton";
import SaveToListButton from "../../components/table-actions-panel/SaveToListButton/SaveToListButton";
import useTrackedWebsitesQuota from "../../hooks/useTrackedWebsitesQuota";

type Props = Omit<SaveToListButtonProps, "tooltipContent"> & {
    renderTooltipContent?: (props: { isOutOfQuota: boolean }) => ReactElement | undefined;
};

const SaveToListButtonBaseContainer = ({ renderTooltipContent, ...props }: Props) => {
    const { isOutOfQuota } = useTrackedWebsitesQuota();

    return (
        <SaveToListButton
            {...props}
            isTooltipDisabled={props.isTooltipDisabled}
            isDisabled={isOutOfQuota || props.isDisabled}
            tooltipContent={renderTooltipContent?.({ isOutOfQuota })}
        />
    );
};

export default SaveToListButtonBaseContainer;
